import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Habilita instalar Carpepel a la pantalla de inicio y cachea estáticos para
// visitas repetidas. No afecta el pre-renderizado por ruta que ya hace el
// servidor (ver src/service-worker.js).
serviceWorkerRegistration.register();
